import type { CreateTokenError, DLocalValidationError } from '#src/app/shared/components/payments';

import { useDLocalMapHttpError } from './useDLocalMapHttpError';
import { useDLocalValidationError } from './useDLocalValidationError';

export type UseDLocalMapErrorResult = {
	mapDLocalValidationError: (dlocalError: CreateTokenError) => {
		field: keyof DLocalValidationError;
		message: string;
	};
	mapDLocalHttpError: (dlocalError: CreateTokenError) => string;
	translateDLocalFieldError: (field: keyof DLocalValidationError) => string | undefined;
};

export function useDLocalMapError(): UseDLocalMapErrorResult {
	const mapDLocalHttpError = useDLocalMapHttpError();
	const { mapDLocalValidationError, translateDLocalFieldError } = useDLocalValidationError();

	return { mapDLocalValidationError, mapDLocalHttpError, translateDLocalFieldError };
}
